<template>
  <div v-cloak v-show="!showed" class="announcement" :style="'background-image: url(\''+ baner_image +'\');'">
    <div class="container">
      <div class="text new-year">
        {{text}}
      </div>
    </div>
    <div class="close-block" @click="changeShowed"></div>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);

// set default config
Vue.$cookies.config('7d')

// set global cookie
Vue.$cookies.set('theme', 'default');
Vue.$cookies.set('hover-time', '1s');


export default {
  name: "BannerCockies",

  props: {
    text: {
      required: false
    }
  },

  data() {
    return {
      baner_image,
      showed: false,
      Lang,
    }
  },

  methods: {
    changeShowed() {
      this.showed = true;
      this.$cookies.set('cookie_showed', true);
    }
  },

  mounted() {
    let showed_cookie = this.$cookies.get('cookie_showed');
    if (showed_cookie) {
      this.showed = true;
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/elements/BannerCockies.vue